import { useLocation, useParams } from 'react-router-dom'

import { Text } from '@factorialco/deprecated-design-system'
import { ProjectManagementProjectDetailsPageEditSubprojectModalPageDocument } from 'generated/resources/graphql'
import { RenameSubprojectDocument, RenameSubprojectMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import EditSubprojectModal, {
  AddEditSubprojectFormValues,
} from 'modules/project_management/components/modals/AddEditSubprojectModal'

const EditSubprojectModalPage = () => {
  const { subprojectId, id } = useParams()
  const { state } = useLocation()
  const { subprojectName } = state || { subprojectName: '' }

  const { data: policies, loading: loadingPolicies } = useQuery(
    ProjectManagementProjectDetailsPageEditSubprojectModalPageDocument
  )

  const [renameSubproject, { loading }] = useMutation(RenameSubprojectDocument, {
    extractorFn: (data: RenameSubprojectMutation) =>
      data.projectManagementMutations.renameProjectmanagementSubproject,
  })

  const canRenameSubproject = policies?.projectManagement._policies.subprojectManage.can

  if (loadingPolicies || !canRenameSubproject) return null

  const onSubmit = ({ name }: AddEditSubprojectFormValues) => {
    track(trackingEvents.projectManagement.subprojects.editSubprojectSubmit, {
      project_id: id,
    })

    return renameSubproject({
      variables: {
        name,
        id: Number(subprojectId),
      },
      optimisticResponse: {
        projectManagementMutations: {
          renameProjectmanagementSubproject: {
            errors: [],
            subproject: {
              id: Number(subprojectId),
              name: subprojectName,
            },
            __typename: 'RenameProjectmanagementSubprojectPayload',
          },
        },
      },
    })
  }

  const description = i18n.tView('project_management.modals.edit_subproject.description', {
    project_name: (
      <Text size="300" weight="bold">
        {subprojectName}
      </Text>
    ),
  })

  return (
    <EditSubprojectModal
      onSubmit={onSubmit}
      loading={loading}
      title={i18n.t('project_management.modals.edit_subproject.title')}
      description={description}
      iconName={'document-edit'}
      nameLabel={i18n.t('project_management.modals.edit_subproject.input_label')}
      submitButton={i18n.t('project_management.modals.edit_subproject.submit')}
      subprojectName={subprojectName}
    />
  )
}

export default EditSubprojectModalPage
